import { useEffect } from 'react'

const useDisableAppsFlyer = () => {
  useEffect(() => {
    if (!window?.AF) return
    window.AF?.('banners', 'hideBanner')
  }, [])

  return null
}

export default useDisableAppsFlyer
